import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appImageLoad]',
})
export class ImageLoadDirective {
  public constructor(private readonly elementRef: ElementRef, private readonly renderer: Renderer2) {
    this.renderer.setStyle(this.elementRef.nativeElement, 'opacity', 0);
    this.renderer.setStyle(this.elementRef.nativeElement, 'transition', 'opacity 300ms ease-in-out');
  }


  @HostListener('error')
  @HostListener('load')
  public onLoad(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'opacity', 1);
  }
}
